var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"quote_source"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"quote_source__inner"},[_c('blockquote',[_c('div',{staticClass:"quote",domProps:{"innerHTML":_vm._s(_vm.quote)}}),_vm._v(" "),(_vm.quote_source)?_c('div',{staticClass:"quote_source",domProps:{"innerHTML":_vm._s(_vm.quote_source)}}):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/QuoteSource.vue